import { alpha } from '@mui/material/styles';
import { gray } from '../themePrimitives';

export const layoutCustomizations = {
  MuiCssBaseline: {
    styleOverrides: (theme) => ({
      body: {
        scrollbarColor: `${gray[400]} ${gray[200]}`,
        '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
          width: 8,
          height: 8,
        },
        '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
          borderRadius: 8,
          backgroundColor: gray[300],
          minHeight: 24,
        },
        '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
          backgroundColor: gray[400],
        },
        ...theme.applyStyles('dark', {
          scrollbarColor: `${gray[700]} ${gray[900]}`,
          '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
            backgroundColor: gray[700],
          },
        }),
      },
    }),
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: 600,
        borderRadius: 10,
      },
      contained: ({ theme }) => ({
        boxShadow: 'none',
        '&:hover': {
          boxShadow: theme.palette.baseShadow || theme.shadows[2],
        },
      }),
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        backgroundColor: theme.palette.background.paper,
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: ({ theme }) => ({
        fontWeight: 600,
        color: theme.palette.text.secondary,
        backgroundColor: alpha(theme.palette.primary.main, 0.04),
        borderBottom: `1px solid ${theme.palette.divider}`,
      }),
      root: ({ theme }) => ({
        borderBottom: `1px solid ${theme.palette.divider}`,
        ...theme.applyStyles('dark', {
          borderColor: alpha(gray[700], 0.7),
        }),
      }),
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        ...theme.applyStyles('dark', {
          '&:hover': {
            backgroundColor: alpha(gray[700], 0.35),
          },
        }),
      }),
    },
  },
};
